import { SectionWithImageStepperProps } from './query';
import ImageStepper from '@/components/blocks/ImageStepper';
import Button_v2 from '@/components/molecules/Button/index';
import MarkdownParser from '@/components/molecules/MarkdownParser';
import Title_v2 from '@/components/molecules/Title/index';
import { renderUnderline } from '@/utilities/functions';

const SectionWithImageStepper = ({ sectionWithImageStepperData }: { sectionWithImageStepperData: SectionWithImageStepperProps }) => {

	return (
		<>
			<Title_v2
				align={sectionWithImageStepperData.title.alignedAt}
				underlineColor={sectionWithImageStepperData.title.underlineColor}
			>
				{renderUnderline(sectionWithImageStepperData.title.titlePieces)}
			</Title_v2>
			<MarkdownParser padding={{ top: '.5rem', bottom: '3rem' }}>
				{sectionWithImageStepperData.description}
			</MarkdownParser>
			<ImageStepper steps={sectionWithImageStepperData.imageSteps} />
			{
				sectionWithImageStepperData.buttons.map(
					(button, index) => (
						<Button_v2
							gtm_id={button.trackerId}
							href={button.url}
							key={index}
							openOnNewTab={button.newTab}
							text={button.text}
							version={button.variant}
						/>
					),
				)
			}
		</>
	);
};

export default SectionWithImageStepper;
